<template>
    <section class="alarms-page">
        <div class="alarms-header">
            <h2>{{$t('message.dashboard_alarms')}}</h2>
            <b-btn type="primary" :disabled="loading || total === 0" @click="archiveAll">{{$t('message.archive_all')}}</b-btn>
        </div>

        <div v-if="!loaded && loading" class="alarms-status text-muted">
            <i class="fa fa-spin fa-spinner mr-2" aria-hidden="true"></i>
            {{ $t('message.loading') }}
        </div>
        <div v-else-if="loaded && alerts.length === 0" class="alarms-status text-muted">
            {{ $t('message.no_records') }}
        </div>
        <div
            v-else-if="alerts.length > 0"
            class="alarms-table-wrap"
            :class="{ 'is-loading': loading }"
        >
            <div v-if="loading" class="alarms-table-overlay" aria-hidden="true">
                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
            </div>
            <div class="table-responsive">
                <table class="table alarms-table">
                    <tr v-for="a in alerts" :key="a.id">
                        <td class="text-grey alarms-col-date">{{a.createdAt}}</td>
                        <td class="text-bold">
                            <i class="fa fa-exclamation-triangle text-red-600"></i>
                            {{a.message}}
                        </td>
                        <td class="text-grey">{{a.path}}</td>
                        <td v-if="a.archived" class="alarms-col-action small-text">
                            <i class="fa fa-check text-success"></i> {{$t('message.archived')}}
                        </td>
                        <td v-else class="alarms-col-action">
                            <b-btn size="sm" @click="archive(a)">{{$t('message.archive')}}</b-btn>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div v-if="pages > 1" class="alarms-pagination">
            <b-btn size="sm" :disabled="loading || page <= 1" @click="goToPage(page - 1)">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                <span>{{$t('message.previous')}}</span>
            </b-btn>
            <span class="alarms-pagination-info">
                {{$t('message.page_of', { page, pages, total })}}
            </span>
            <b-btn size="sm" :disabled="loading || page >= pages" @click="goToPage(page + 1)">
                <span>{{$t('message.next')}}</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </b-btn>
        </div>
    </section>
</template>

<script>
    import {ALERT_REQUEST} from '../_store'

    const PAGE_SIZE = 50

    export default {
        name: 'Alarms',
        data () {
            return {
                alerts: [],
                loaded: false,
                loading: false,
                page: 1,
                pages: 1,
                total: 0,
                limit: PAGE_SIZE
            }
        },
        methods: {
            archive (alert) {
                this.$store.dispatch(ALERT_REQUEST, {action: 'update', id: alert.id, request: {archive: true}})
                  .then(() => {
                      alert.archived = true
                  })
            },
            archiveAll () {
                this.$store.dispatch(ALERT_REQUEST, {action: 'update', request: {archive: true}})
                  .then(() => {
                      this.load(1)
                  })
            },
            goToPage (page) {
                if (page < 1 || page > this.pages || page === this.page) {
                    return
                }
                this.load(page)
            },
            load (page = this.page) {
                this.loading = true
                this.$store.dispatch(ALERT_REQUEST, {
                    action: 'read',
                    all: 1,
                    limit: this.limit,
                    page
                })
                    .then(resp => {
                        const list = resp.data.alerts
                        this.alerts = Array.isArray(list) ? list : Object.values(list || {})
                        this.total = Number(resp.data.total || 0)
                        this.page = Number(resp.data.page || page)
                        this.pages = Number(resp.data.pages || 1)
                        this.limit = Number(resp.data.limit || this.limit)
                        this.loaded = true
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        created () {
            this.load(1)
        }
    }
</script>

<style scoped>
  .alarms-page {
    width: 100%;
  }
  .alarms-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }
  .alarms-header h2 {
    margin: 0;
    margin-right: auto;
  }
  .alarms-status {
    padding: 2rem 0.5rem;
    text-align: center;
  }
  .alarms-table-wrap {
    position: relative;
    min-height: 12rem;
    transition: opacity 0.2s ease;
  }
  .alarms-table-wrap.is-loading {
    opacity: 0.55;
    pointer-events: none;
  }
  .alarms-table-overlay {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4a5568;
    font-size: 1.25rem;
    pointer-events: none;
  }
  .alarms-table {
    width: 100%;
  }
  .alarms-table td {
    vertical-align: middle;
  }
  .alarms-col-date {
    white-space: nowrap;
    width: 1%;
  }
  .alarms-col-action {
    white-space: nowrap;
    width: 1%;
    text-align: right;
  }
  .alarms-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 1rem;
  }
  .alarms-pagination :deep(.btn) {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
  }
  .alarms-pagination-info {
    color: #718096;
    font-size: 0.875rem;
    min-width: 10rem;
    text-align: center;
  }
  .small-text {
    font-size: 14px;
  }
  .text-bold {
    font-weight: 600;
  }
  .text-grey {
    color: #8c8c8c;
  }
</style>
